import { createRouter, createWebHistory } from 'vue-router';
import OpenAIChat from '@/pages/OpenAIChat.vue';
import ImpressumPage from '@/pages/ImpressumPage.vue';
import DatenschutzPage from '@/pages/DatenschutzPage.vue';
import RssPage from '@/pages/RssPage.vue';
import Typo3ApiPage from "@/pages/Typo3ApiPage.vue";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: OpenAIChat,
    },
    {
        path: '/impressum',
        name: 'ImpressumPage',
        component: ImpressumPage,
    },
    {
        path: '/typo3-api',
        name: 'Typo3ApiPage',
        component: Typo3ApiPage,
    },
    {
        path: '/datenschutz',
        name: 'DatenschutzPage',
        component: DatenschutzPage,
    },
    {
        path: '/rss',
        name: 'RssPage',
        component: RssPage,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;